let loadedClient = null;

export function loadAdsense(clientId) {
  if (!clientId || loadedClient) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
  s.crossOrigin = "anonymous";
  s.setAttribute("data-ad-frequency-hint", "30s");
  if (process.env.NODE_ENV !== "production") s.setAttribute("data-adbreak-test", "on");
  document.head.appendChild(s);
  window.adsbygoogle = window.adsbygoogle || [];
  window.adBreak = window.adConfig = function (o) { window.adsbygoogle.push(o); };
  window.adConfig({ preloadAdBreaks: "on" });
  loadedClient = clientId;
}

// Resolves "viewed" | "dismissed" | "unavailable"
export function showRewardedAd() {
  if (!loadedClient || !window.adBreak) return Promise.resolve("unavailable");
  return new Promise((resolve) => {
    let result = null;
    window.adBreak({
      type: "reward",
      name: "extra_life",
      beforeReward: (showAdFn) => showAdFn(),
      adViewed: () => { result = "viewed"; },
      adDismissed: () => { result = "dismissed"; },
      adBreakDone: () => resolve(result || "unavailable"),
    });
  });
}
